module.exports = __webpack_public_path__ + "media/images/gifts/light/sug_luz_3-76994338dcaa3d78abe9d8a42911948f.jpg";